import { getSelectedWebsiteGuid } from "../tracked_websites/selectors";

export const getTrackedKeywordsCount = (state) => state.tracked_keywords.tracked_keywords_count;

export const getSelectedDomainKeywords = (state) => {
  let selectedDomainGuid = getSelectedWebsiteGuid(state);
  let selectedDomain = state.tracked_keywords.domains[selectedDomainGuid];

  if (!selectedDomain || (selectedDomain && !("keywords" in selectedDomain))) {
    return [];
  }
  return selectedDomain.keywords;
};

export const isFetchingTrackedKeywords = (state) => {
  const selectedDomainGuid = getSelectedWebsiteGuid(state);

  const keywords = getSelectedDomainKeywords(state);
  if (keywords.length) {
    return false;
  }
  return state.tracked_keywords.network_activity.includes(`fetch_tracked_keywords_${selectedDomainGuid}`);
};

export const isFetchingKeywordsCount = (state) => {
  const trackedKeywordsCount = state.tracked_keywords.tracked_keywords_count;
  if (trackedKeywordsCount) {
    return false;
  }
  return state.tracked_keywords.network_activity.includes("fetch_keywords_count");
};

export const isFetchingTopDomains = (state, h_key) => {
  return state.tracked_keywords.network_activity.includes(`fetch_top_domains_${h_key}`);
};

export const isAddingTrackedKeywords = (state) => {
  return state.tracked_keywords.network_activity.some((msg) => msg.indexOf("add_tracked_keywords_") > -1);
};

export const isChangingSeoDb = (state) =>
  state.tracked_keywords.network_activity.some((msg) => msg.indexOf("change_seo_db_") > -1);

export const keywordsBeingDeleted = (state) => {
  const keywords = getSelectedDomainKeywords(state);
  const selectedDomainGuid = getSelectedWebsiteGuid(state);
  return keywords.reduce((acc, keyword) => {
    if (state.tracked_keywords.network_activity.includes(`deleting_keyword_${keyword.phrase}${selectedDomainGuid}`)) {
      acc.push(keyword.phrase);
    }
    return acc;
  }, []);
};

export const keywordOverviewInProgress = (state) => {
  const keywords = getSelectedDomainKeywords(state);
  return keywords.some((keyword) => "status" in keyword);
};

export const addedKeywords = (state, keywordsToAdd) => {
  const currentKeywords = getSelectedDomainKeywords(state);
  return keywordsToAdd.every((phrase) => currentKeywords.map((keyword) => keyword.phrase).includes(phrase));
};

export const isFetchingKeywordOverview = (state, h_key) => {
  return state.tracked_keywords.network_activity.includes(`fetch_overview_${h_key}`);
};

export const getKeywordOverviews = (state, keywordHashKey) => {
  if (keywordHashKey in state.tracked_keywords.overviews) {
    return state.tracked_keywords.overviews[keywordHashKey].map((keyword) => {
      keyword["pos"] = parseInt(keyword["pos"]);
      return keyword;
    });
  }
  //return [{ pos: 0 }];
};

export const getTopDomains = (state, hKey) => state.tracked_keywords.top_domains[hKey];
